// Autogenerated file
export const subscriptionStatesEnum = {
    Planned: "Planned",
    Processing: "Processing",
    ProcessingError: "ProcessingError",
    Active: "Active",
    Ended: "Ended",
};
export const subscriptionStates = [
    { label: "Запланировано создание", value: "Planned" },
    { label: "В обработке", value: "Processing" },
    { label: "Ошибка обработки", value: "ProcessingError" },
    { label: "Активная", value: "Active" },
    { label: "Завершенная", value: "Ended" },
];
